import { pletApiRequest } from './client';

export const WorkspaceAPI = {
  list: async () => {
    const result = await pletApiRequest('/workspaces');
    return result;
  },
  listPendingInvites: async () => pletApiRequest('/workspaces?inbox=1'),
  create: async (name, plan) => {
    const result = await pletApiRequest('/workspaces', {
      method: 'POST',
      body: JSON.stringify({ name, ...(plan ? { plan } : {}) }),
    });
    return result;
  },
  rename: async (workspaceId, name) => {
    const result = await pletApiRequest(
      `/workspaces/${encodeURIComponent(workspaceId)}`,
      { method: 'PATCH', body: JSON.stringify({ name }) },
    );
    return result;
  },
  members: async (workspaceId) => {
    const result = await pletApiRequest(`/workspaces/${encodeURIComponent(workspaceId)}/members`);
    return result;
  },
  updateMemberRole: async (workspaceId, memberSub, role) => {
    const result = await pletApiRequest(
      `/workspaces/${encodeURIComponent(workspaceId)}/members/${encodeURIComponent(memberSub)}`,
      { method: 'PATCH', body: JSON.stringify({ role }) },
    );
    return result;
  },
  removeMember: async (workspaceId, memberSub) => {
    const result = await pletApiRequest(
      `/workspaces/${encodeURIComponent(workspaceId)}/members/${encodeURIComponent(memberSub)}`,
      { method: 'DELETE' },
    );
    return result;
  },
  createInvite: async (workspaceId, { email, role = 'user' }) => {
    const result = await pletApiRequest(
      `/workspaces/${encodeURIComponent(workspaceId)}/invites`,
      { method: 'POST', body: JSON.stringify({ email, role }) },
    );
    return result;
  },
  listInvites: async (workspaceId) => {
    const result = await pletApiRequest(`/workspaces/${encodeURIComponent(workspaceId)}/invites`);
    return result;
  },
  deleteInvite: async (workspaceId, inviteId) => {
    const result = await pletApiRequest(
      `/workspaces/${encodeURIComponent(workspaceId)}/invites/${encodeURIComponent(inviteId)}`,
      { method: 'DELETE' },
    );
    return result;
  },
  acceptInvite: async (workspaceId, inviteId) => {
    const result = await pletApiRequest('/invites/accept', {
      method: 'POST',
      body: JSON.stringify({ workspaceId, inviteId }),
    });
    return result;
  },
};
